// src/pages/Terms.js
import React from "react";
import "../CSS/Term.css";                   // <-- aapka existing CSS
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/signup");
  };

  return (
    <div>
      {/* Page Header */}
      <section className="tm-page-header">
        <button className="back-btn" onClick={handleBack}>
          &larr; Back
        </button>

        <div className="tm-container">
          <h1>Terms and Conditions</h1>
          <p>
            Last Updated: 27/06/2025 | Governing Entity: Vithal Visions Private
            Limited (CIN: U59141PN2025PTC237150)
          </p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="terms-content">
        <div className="tm-container">
          {/* Section 1 */}
          <div className="terms-section">
            <h2>1. Definitions</h2>
            <ul>
              <li>
                <strong>"Platform"</strong>: Cinevestor.in website and associated services
              </li>
              <li>
                <strong>"Contributor"</strong>: Individual/organization providing funds
              </li>
              <li>
                <strong>"Filmmaker"</strong>: Project owner registered on the platform
              </li>
              <li>
                <strong>"Talent"</strong>: Actors/technicians hired through the platform
              </li>
            </ul>
          </div>

          {/* Section 2 */}
          <div className="terms-section">
            <h2>2. Eligibility & Registration</h2>
            <h3>2.1 Users must:</h3>
            <ul>
              <li>Be 18+ years old</li>
              <li>Provide accurate KYC details (if contributing 20,000+)</li>
              <li>Maintain account confidentiality</li>
            </ul>

            <h3>2.2 Prohibited users:</h3>
            <ul>
              <li>Those previously banned for fraud</li>
              <li>Entities on RBI/SEBI watchlists</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div className="terms-section">
            <h2>3. Contribution Terms</h2>
            <h3>3.1 For Contributors:</h3>
            <ul>
              <li>Funds are <strong>non-refundable</strong> except under Section 5</li>
              <li>Profit-sharing (up to 25%) is <strong>not guaranteed</strong></li>
              <li>12-18 month profit distribution timeline</li>
            </ul>

            <h3>3.2 For Filmmakers:</h3>
            <ul>
              <li>Must disclose project risks transparently</li>
              <li>Required to provide quarterly progress updates</li>
            </ul>
          </div>

          {/* Section 4 */}
          <div className="terms-section">
            <h2>4. Intellectual Property</h2>
            <ul>
              <li>Platform content is owned by <strong>Vithal Visions Pvt Ltd</strong></li>
              <li>Project IP remains with respective filmmakers</li>
              <li>User-generated content license grants Cinevestor royalty-free usage rights for promotion</li>
            </ul>
          </div>

          {/* Section 5 */}
          <div className="terms-section">
            <h2>5. Refund & Cancellation</h2>
            <table className="terms-table">
              <thead>
                <tr>
                  <th>Scenario</th>
                  <th>Policy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>No progress in 140 days</td>
                  <td>Full refund</td>
                </tr>
                <tr>
                  <td>Project cancellation</td>
                  <td>Pro-rata refund after deductions</td>
                </tr>
                <tr>
                  <td>Contributor withdrawal</td>
                  <td>No refund (funds locked)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 6 */}
          <div className="terms-section">
            <h2>6. Dispute Resolution</h2>
            <ul>
              <li><strong>Mediation:</strong> Mandatory 30-day negotiation period</li>
              <li><strong>Arbitration:</strong> Final settlement in Gondia, Maharashtra</li>
              <li><strong>Governing Law:</strong> Indian Contract Act, 1872</li>
            </ul>
          </div>

          {/* Section 7 */}
          <div className="terms-section">
            <h2>7. Limitation of Liability</h2>
            <p>Cinevestor is <strong>not liable</strong> for:</p>
            <ul>
              <li>Project failures or profit losses</li>
              <li>Technical outages beyond 72 hours</li>
              <li>Third-party actions (payment gateways, filmmakers)</li>
            </ul>
          </div>

          {/* Section 8 */}
          <div className="terms-section">
            <h2>8. Termination Policy</h2>
            <h3>8.1 We may suspend accounts for:</h3>
            <ul>
              <li>Fraudulent activity</li>
              <li>Violation of these terms</li>
              <li>Regulatory requirements</li>
            </ul>
            <h3>8.2 Users may delete accounts via dashboard</h3>
          </div>

          {/* Section 9 */}
          <div className="terms-section">
            <h2>9. Amendments</h2>
            <ul>
              <li>30-day notice for major changes</li>
              <li>Continued use constitutes acceptance</li>
            </ul>
          </div>

          {/* Section 10 */}
          <div className="terms-section">
            <h2>10. Contact Information</h2>
            <ul>
              <li><strong>Grievance Officer:</strong> [Name]</li>
              <li><strong>Email:</strong> legal@cinevestor.in</li>
              <li><strong>Address:</strong> Daya House, Khairlanji Road, Tiroda, Dist.Gondia-441911,Maharashtra</li>
            </ul>
          </div>

          {/* Annexures */}
          <div className="terms-section">
            <h2>Annexures</h2>
            <ul>
              <li>A. List of Prohibited Activities</li>
              <li>B. State-wise Legal Addendums</li>
              <li>C. Fee Structure</li>
              <li>D. Data Processing Agreement</li>
              <li>E. Force Majeure</li>
              <li>F. Cookie Policy</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
